import { createContext } from 'react';

import { AnnotationsTrackConfig } from '../../core/components/annotations/types/annotations-track-props.js';

export const XYChartAnnotationsDataContext = createContext<
  Map<string, AnnotationsTrackConfig>
>(new Map<string, AnnotationsTrackConfig>());
